import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

export const getJobProcess = () => {
  return axios({
    method: "get",
    url: BASE_URL + "api/secure/user/v1/job-process",
    headers: getHeaders(),
  });
};

export const postJobProcess = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "api/secure/user/v1/job-process",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
